import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {Store} from '@ngrx/store';
import {catchError, map, mergeMap, take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {AUTH_TOKEN} from '../../modules/auth/consts';
import {AuthSelectors} from '../../modules/auth/store/selectors';
import {ToastrService} from 'ngx-toastr';

export const RT_API = '{rt-api}';
export const LUMII_API = '{lumii-api}';


@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(
    private store: Store,
    // private messageService: MessageService,
    private toast: ToastrService,
    private router: Router
  ) {
  }

  catch(err: { message: any; }, url: string): Observable<any> {
    // console.log(err.message);
    this.toast.error(err.message, 'Error');
    // this.messageService.add(
    //   { severity: 'error', summary: 'Error', detail: err.message }
    // );

    return throwError(err);
  }


  getFullUrl(req: any) {
    if (req.urlWithParams.search(LUMII_API) >= 0) {

      return environment.LUMII_API + req.urlWithParams.replace(LUMII_API, '');
    }

    if (req.urlWithParams.search(RT_API) >= 0) {
      return environment.RT_API + req.urlWithParams.replace(RT_API, '');
    }

    return req.urlWithParams;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let httpRequest = req.clone({
      url: this.getFullUrl(req)
    });

    return this.store.select(AuthSelectors.token).pipe(
      take(1),
      mergeMap((token) => {
        // const date = moment.utc().format('YYYY-MM-DD HH:mm:ss');
        // const stillUtc = moment.utc(date).toDate();
        // const local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
        // const timezoneOffset = moment.parseZone(Date.now()).utcOffset() / 60;

        httpRequest = httpRequest.clone({
          headers: new HttpHeaders({Authorization: 'Bearer ' + token, Accept: httpRequest.headers.get('Accept') || 'application/json'})
        });

        return next.handle(httpRequest);
      }),
      map( (event: any) => {
        // console.log(event)
        if (event?.type === 3) {
          return event;
        }
        if (event instanceof HttpResponse) {
         // console.log(event)
          if (event.body.result === 'ERROR') {
            throw new Error(event.body.message);
          } else {
            const url = event?.url?.toLowerCase();
            return event.clone({body: event.body.data});
          }
        }
        return;
      }),
      catchError(err => {
        if (err.status === 500 || err.status === 502 || err.status === 503) {

          // this.messageService.add(
          //   { severity: 'error', summary: 'Error', detail: 'Oops! something went wrong' }
          // );
          this.toast.error( 'Oops! something went wrong', 'Error');
          return throwError(err);
        }

        if (err.status === 401) {
          // this.messageService.add(
          //   { severity: 'error', summary: 'Error', detail: 'Session has expired!' }
          // );
          this.toast.error( 'Session has expired!', 'Error');
          localStorage.removeItem(AUTH_TOKEN);
          this.router.navigate(['auth/login']);
          return of(null);
        } else {
          return this.catch(err, httpRequest.url);
        }
      })
    );

  }
}
